import { render, staticRenderFns } from "./BudgetMainSummary.vue?vue&type=template&id=6a5ba148&scoped=true"
import script from "./BudgetMainSummary.vue?vue&type=script&lang=js"
export * from "./BudgetMainSummary.vue?vue&type=script&lang=js"
import style0 from "./BudgetMainSummary.vue?vue&type=style&index=0&id=6a5ba148&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5ba148",
  null
  
)

export default component.exports